<template>
  <div class="ui ui-game">
    <footer class="ui-game__footer">
      <GameProgressbar />

      <GameScore />
    </footer>
  </div>
</template>

<script>
import GameScore from '@/components/GameScore.vue';
import GameProgressbar from '@/components/GameProgressbar.vue';

export default {
  name: 'Game',

  components: {
    GameProgressbar,
    GameScore,
  },

  data() {
    return {
      muted: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.ui-game {
  text-align: center;
  color: $color-white;

  &__footer {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;

    padding: 20px;

    display: flex;
    align-items: center;
    justify-content: flex-end;

    @include mq(ipadP) {
      padding: 30px;
      justify-content: space-between;
    }

    @include mq(dm) {
      padding: 40px;
    }
  }
}
</style>
